<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

<div data-automation="user-detail-phone">
  @if (phoneType !== PhoneType.EXTENSION_MOBILITY && !isLoading) {
    <ziro-phone (save$)="onSave($event)" (delete$)="goHome()" (cancel$)="goHome()"></ziro-phone>
  }
  @if (phoneType === PhoneType.EXTENSION_MOBILITY && !isLoading) {
    <ziro-extension-mobility
      [endUserRef]="endUserRef"
      [global360View]="global360View"
      (save$)="onSave($event)"
      (delete$)="goHome()"
      (cancel$)="goHome()"
    ></ziro-extension-mobility>
  }
</div>
